import "./App.css"
import Home from "./Home"
import About from "./About"
import Services from "./Service"
import Projects from "./Project"
import Blog from "./Blog"
import "./Blog.css"
import Contact from "./Contact"
import Footer from "./Footer"

function App() {
  return (
    <div className="App">
      <Home />
      <About />
      <Services />
      <Projects />
      <Blog />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
